// extracted by mini-css-extract-plugin
module.exports = {"mdBreakPoint":"992","navigation":"_28gaA6y_wkEKqpRA"};